export const preloadImage = (src: string) =>
  new Promise<{ height: number; width: number }>((resolve, reject) => {
    const img = new Image()
    img.onload = function () {
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    }

    img.onerror = (_ev, _src, _lineno, _colno, err) => {
      reject(err)
    }

    img.src = src
  })

export const getAspectRatio = (height: number, width: number): string =>
  height > 0 && width > 0 ? `${width} / ${height}` : `3 / 4`

export const getHiResImagePath = (image: string) => image.replace(/q_auto/, 'q_100')
